"use client";

import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";
import { fieldBaseClass, labelClass } from "@/shared/ui/form/field-styles";

export function SqmStep() {
  const { state, setState, goToStep, step, stepReady, isBusiness } = useWizard();

  return (
    <section>
      <StepHeading
        title={isBusiness ? "Hvor stort er arealet?" : "Hvor stor er boligen?"}
        body="Et ca. tal er fint - det bruges til at vurdere tidsforbrug og pris."
      />
      <label htmlFor="wiz-sqm" className={labelClass}>
        {isBusiness ? "Areal (m²)" : "Boligens størrelse (m²)"}
      </label>
      <input
        id="wiz-sqm"
        type="text"
        inputMode="numeric"
        placeholder={isBusiness ? "fx 250" : "fx 85"}
        value={state.squareMeters}
        onChange={(e) =>
          setState((prev) => ({
            ...prev,
            squareMeters: e.target.value.replace(/\D/g, "").slice(0, 5),
            bbrPrefilled: { ...prev.bbrPrefilled, sqm: false },
          }))
        }
        className={`${fieldBaseClass} max-w-48`}
      />
      {state.bbrPrefilled.sqm &&
        (isBusiness ? (
          // BBR's m² is for the whole building - for erhverv (office in a
          // multi-tenant building, shop on a high street, clinic in a leased
          // complex) this typically differs from the area actually being
          // cleaned, hence the warning.
          <div className="mt-3 max-w-120 rounded border border-border bg-paper px-3 py-2.5 text-[13px] text-ink-muted">
            <strong className="text-ink">Bemærk:</strong> BBR-arealet dækker hele bygningen og kan
            afvige fra jeres lokale. Ret det her hvis I lejer en del af bygningen.
          </div>
        ) : (
          <p className="mt-2 text-[13px] text-ink-subtle">Hentet fra BBR - ret hvis nødvendigt.</p>
        ))}
      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("sqm")}
        nextLabel="Næste →"
      />
    </section>
  );
}
